import * as reselect from 'reselect';
import { getSelectedVideoEffect } from './baseSelectors';
import { VideoBackgroundEffect } from '@azure/communication-react';


export const activeVideoBackgroundEffectSelector = reselect.createSelector(
    [getSelectedVideoEffect],
    (selectedVideoBackgroundEffect?: VideoBackgroundEffect) => {
        if (
            selectedVideoBackgroundEffect &&
            (selectedVideoBackgroundEffect.effectName === 'blur' || selectedVideoBackgroundEffect.effectName === 'none')
        ) {
            return selectedVideoBackgroundEffect.effectName;
        } else if (selectedVideoBackgroundEffect && selectedVideoBackgroundEffect.effectName === 'replacement') {
            return selectedVideoBackgroundEffect?.key;
        }
        return 'none';
    }
);
